
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-9081.5 2894.25 11.662 11.668"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_151_64","data-name":"Symbol 151 – 64","transform":"translate(-10658 2313.001)","opacity":".54"}},[_c('g',{attrs:{"id":"Group_3272","data-name":"Group 3272","transform":"translate(1577 582)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_2093","d":"M6.6 2.2h2.83v8.833H.6V8.2","data-name":"Path 2093","transform":"translate(.983 -.866)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_2094","d":"M11.45.6L5.7 6.35","data-name":"Path 2094","transform":"rotate(-90 5.55 5.9)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_2095","d":"M8.2.6h3.667v3.667","data-name":"Path 2095","transform":"rotate(-90 5.758 6.108)"}})])])])
          )
        }
      }
    